import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import editIcon from "../../../assets/images/Edit.svg";
import deleteIcon from "../../../assets/images/Delete.svg";
import { getPlusSignInCountryCode } from "../../../common/CommonFunctions";
import { MuiDataGridStyle } from "../../../theme/App.theme";
import NoRecordsToDisplay from "../../../components/CommonReusableComponent/NoRecordsToDisplay/NoRecordsToDisplay";

const UserMasterDataTable_V2 = ({
  Rows,
  GetRowDataOnClickOfAction,
  PageSizeOptions,
  RowsToDisplay,
}) => {
  const Columns = [
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 90,
      maxWidth: 90,
      renderCell: (param) => (
        <div className="d-flex justify-content-center align-items-center h-100 gap-3">
          <img
            src={editIcon}
            className="cursor-pointer"
            alt={"Edit"}
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              GetRowDataOnClickOfAction("Update Branch", param.row);
            }}
          />
          <img
            src={deleteIcon}
            className="cursor-pointer"
            alt={"Delete"}
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              GetRowDataOnClickOfAction("Delete Branch", param.row);
            }}
          />
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "abbreviation",
      headerName: "Unique Prefix",
      sortable: false,
      width: 130,
    },
    {
      field: "emergencyContactNumber",
      headerName: "Emergency Contact Number",
      sortable: false,
      flex: 1,
      minWidth: 250,
      valueGetter: (value, row) =>
        `${getPlusSignInCountryCode(row["emergencyContactNumberCountryCode"])} ${value}` ||
        "Not Available",
    },
    {
      field: "address",
      headerName: "Branch Address",
      sortable: false,
      flex: 1,
      minWidth: 350,
    },
  ];

  return (
    <React.Fragment>
      <div className="w-100">
        <DataGrid
          columns={Columns}
          rows={Rows}
          slots={{
            noRowsOverlay: NoRecordsToDisplay,
          }}
          pageSizeOptions={PageSizeOptions || [5, 10, 15, 25, 50]}
          initialState={{
            density: "compact",
            pagination: {
              paginationModel: {
                pageSize: RowsToDisplay || 10,
              },
            },
          }}
          disableRowSelectionOnClick
          density="compact"
          className="custom-data-grid"
          sx={MuiDataGridStyle}
        />
      </div>
    </React.Fragment>
  );
};

export default UserMasterDataTable_V2;
